import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const resumeOnHold = async (chatId: string): Promise<AxiosResponse> =>
  AxiosInstance.post('livechat/room.resumeOnHold', {
    roomId: chatId,
  });
